import ReservationRepository from '../../domain/repositories/ReservationRepository';
import ReservationDataStoreFactory from '../factories/ReservationDataStoreFactory';
import ReservationDataStore from '../datastores/ReservationDataStore';

export default class ReservationDataRepository
  implements ReservationRepository
{
  getCampusTablets() {
    const reinforcementDataStore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return reinforcementDataStore.getCampusTablets();
  }

  getDatesTablet(idLibrary: number) {
    const reinforcementDataStore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return reinforcementDataStore.getDatesTablet(idLibrary);
  }

  getDatesComputer(idLibrary: number) {
    const reinforcementDataStore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return reinforcementDataStore.getDatesComputer(idLibrary);
  }

  subscribeResourceTablet(hours: number, hourStart: number, idLibrary: number) {
    const reinforcementDataStore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return reinforcementDataStore.subscribeResourceTablet(
      hours,
      hourStart,
      idLibrary
    );
  }

  subscribeResourceComputer(
    hours: number,
    hourStart: number,
    idLibrary: number
  ) {
    const reinforcementDataStore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return reinforcementDataStore.subscribeResourceComputer(
      hours,
      hourStart,
      idLibrary
    );
  }

  getTabletDetail(id: string) {
    const resourcesDatastore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return resourcesDatastore.getTabletDetail(id);
  }

  cancelReservation(id: string) {
    const resourcesDatastore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return resourcesDatastore.cancelReservation(id);
  }

  getSubscribedsTablets() {
    const reservationsDataStore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return reservationsDataStore.getSubscribedsTablets();
  }

  getStatusResource() {
    const statusResourceDataStore: ReservationDataStore =
      ReservationDataStoreFactory.create();
    return statusResourceDataStore.getStatusResource();
  }
}
